import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Collapse from '../collapse'
import Search from '../search'
import { events, actions } from '../../../helpers/analytics-utils/constants'
import style from './index.module.scss'
import CategoryFilter from './category-filter'
import RadioFilter from './radio-filter'
import PriceFilter from './price-filter'

const Filter = ({
  filterState,
  facets,
  buildUrl,
  history,
  categoriesHierarchy,
}) => {
  // When switching these filters (except price) unset the price filter
  const unsetPriceFilterAndBuildUrl = update =>
    buildUrl(
      Object.assign(update, {
        maxPrice: undefined,
        minPrice: undefined,
        onSale: false,
      })
    )

  return (
    <Fragment>
      <Search
        placeholder={'Refine by keyword'}
        history={history}
        searchQuery={filterState.searchQuery}
        buildUrl={update => buildUrl(update)}
        className={style.searchBar}
      />
      {Object.keys(facets.categories).map((rootPath, index) => (
        <CategoryFilter
          key={`category_${index}`}
          rootPath={rootPath}
          availableCategories={facets.categories[rootPath]}
          buildUrl={unsetPriceFilterAndBuildUrl}
          categoriesHierarchy={categoriesHierarchy}
        />
      ))}
      <Collapse
        heading={'Price'}
        className={style.collapse}
        isExpanded={
          filterState.maxPrice !== undefined ||
          filterState.minPrice !== undefined ||
          filterState.onSale
        }
        analyticsEvent={events.FILTER_PRICE}
        analyticsEventAction={actions.FILTER_PRICE}
      >
        <PriceFilter
          minPrice={facets.minPrice}
          maxPrice={facets.maxPrice}
          buildUrl={buildUrl}
          showSale={facets.saleItems}
          onSale={filterState.onSale}
        />
      </Collapse>
      <Collapse
        heading={'Colour'}
        className={style.collapse}
        isExpanded={filterState.color !== undefined}
        analyticsEvent={events.FILTER_COLOR}
        analyticsEventAction={actions.FILTER_COLOR}
      >
        <RadioFilter
          availableValues={facets.colors}
          currentValue={filterState.color}
          buildUrl={unsetPriceFilterAndBuildUrl}
          param="color"
          analyticsEvent={events.FILTER_COLOR}
          analyticsEventAction={actions.FILTER_COLOR}
          analyticsEventParam="colour"
        />
      </Collapse>
      <Collapse
        heading={'Store'}
        className={style.collapse}
        isExpanded={filterState.store !== undefined}
        analyticsEvent={events.FILTER_STORE}
        analyticsEventAction={actions.FILTER_STORE}
      >
        <RadioFilter
          availableValues={facets.retailers}
          currentValue={filterState.store}
          buildUrl={unsetPriceFilterAndBuildUrl}
          param="store"
          valueType="object"
          analyticsEvent={events.FILTER_STORE}
          analyticsEventAction={actions.FILTER_STORE}
          analyticsEventParam="storeName"
        />
      </Collapse>
      <Collapse
        heading={'Brand'}
        className={style.collapse}
        isExpanded={filterState.brand !== undefined}
        analyticsEvent={events.FILTER_BRAND}
        analyticsEventAction={actions.FILTER_BRAND}
      >
        <RadioFilter
          availableValues={facets.brands}
          currentValue={filterState.brand}
          buildUrl={unsetPriceFilterAndBuildUrl}
          param="brand"
          analyticsEvent={events.FILTER_BRAND}
          analyticsEventAction={actions.FILTER_BRAND}
          analyticsEventParam="brand"
        />
      </Collapse>
    </Fragment>
  )
}

Filter.propTypes = {
  filterState: PropTypes.object.isRequired,
  buildUrl: PropTypes.func.isRequired,
  facets: PropTypes.shape({
    colors: PropTypes.arrayOf(PropTypes.string).isRequired,
    brands: PropTypes.arrayOf(PropTypes.string).isRequired,
    minPrice: PropTypes.number.isRequired,
    maxPrice: PropTypes.number.isRequired,
    retailers: PropTypes.array,
    saleItems: PropTypes.bool,
    categories: PropTypes.object,
  }),
  history: PropTypes.object.isRequired,
  categoriesHierarchy: PropTypes.array.isRequired,
}

export default Filter
